import { Routes, Route } from 'react-router-dom';
import Disclaimer from './Disclaimer';
import Home from './Home';
import About from './About';
import Career from './Career';
import Contact from './Contact';
import CCLFamily from './CCLFamily';
import CCLLop from './CCLLop';
import Cheq from './Cheq';
import Will from './Will';
import LandRevenue from './LandRevenue';
import Commercial from './Commercial';
import Consumer from './ConsumerProtection';
import Dispute from './Dispute';
import Intellectual from './Intellectual';
import Corporate from './Corporate';
import DraftCC from './DraftingCC';
import DraftTenders from './DraftingTenders';
import Success from './Success';

function App() {
  return (
    <div>
      <Routes>
        <Route path='/' element={<Disclaimer />} />
        <Route path='/home' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/career' element={<Career />} />
        <Route path='/success' element={<Success />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/cclfamily' element={<CCLFamily />} />
        <Route path='/ccllop' element={<CCLLop />} />
        <Route path='/cheq' element={<Cheq />} />
        <Route path='/will' element={<Will />} />
        <Route path='/landrevenue' element={<LandRevenue />} />
        <Route path='/commercial' element={<Commercial />} />
        <Route path='/consumer' element={<Consumer />} />
        <Route path='/dispute' element={<Dispute />} />
        <Route path='/intellectual' element={<Intellectual />} />
        <Route path='/corporate' element={<Corporate />} />
        <Route path='/draftcc' element={<DraftCC />} />
        <Route path='/drafttender' element={<DraftTenders />} />
      </Routes>
    </div>
  );
}

export default App;